import styled from '@emotion/styled';

export const ButtonContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  > * {
    margin-right: ${(p) => p.theme.spacing()}px;
    margin-bottom: ${(p) => p.theme.spacing()}px;
  }
`;

export const ButtonsSpreadOut = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonsFlexEnd = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  > :not(:first-of-type) {
    margin-left: ${(p) => p.theme.spacing()}px;
  }
`;
